export function formatCpf(cpf) {
  return cpf && cpf.length === 11
    ? cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    : cpf;
}

export function formatPhone(phone) {
  if (phone) {
    if (phone.length === 10) {
      return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1)$2-$3');
    }
    if (phone.length === 11) {
      return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1)$2-$3');
    }
  }
  return '';
}

export function concatPhones(item) {
  const phones = [
    formatPhone(item.phone),
    formatPhone(item.cellPhone),
    formatPhone(item.cellPhoneAux),
  ];
  return phones.join(' / ');
}

export function formatDateDayMonthWeekDay(dateInMilliseconds, t) {
  const date = new Date(dateInMilliseconds);
  if (date) {
    const day = date.getDay();
    let dayName = '';
    switch (day) {
      case 0:
        dayName = 'sun';
        break;
      case 1:
        dayName = 'mon';
        break;
      case 2:
        dayName = 'tue';
        break;
      case 3:
        dayName = 'wed';
        break;
      case 4:
        dayName = 'thu';
        break;
      case 5:
        dayName = 'fri';
        break;
      case 6:
        dayName = 'sat';
        break;
      default:
        break;
    }

    if (dayName) {
      dayName = t(`general.weekdays.short.${dayName}`);
    }
    let monthDay = date.getDate();
    let month = date.getMonth() + 1;
    monthDay = monthDay.length === 1 ? `0${monthDay}` : monthDay;
    month = month.toString().length === 1 ? `0${month}` : month;
    return `${monthDay}/${month} - ${dayName}`;
  }
  return date.toString();
}
